import * as Sentry from '@sentry/react';

// Wrap a Supabase error (or any unknown thrown value) as a proper
// Error before sending to Sentry. Without this, Supabase's bare
// { code, details, hint, message } objects land in Sentry as
// "Object captured as exception with keys: ..." events with no
// stack and no useful grouping. The raw object is preserved under
// `extra.supabaseError` for inspection.
//
// `area` is a stable tag for the operation site, e.g.
// "routes.detail.assign_driver" or "orders.detail.cancel_order".
// Use the same string across the success-path Sentry breadcrumb
// and any related error captures so the tag clusters in Sentry's
// search.
export function captureSupabaseError(
  error: { message: string } | unknown,
  area: string,
): void {
  const wrapped =
    typeof error === 'object' && error !== null && 'message' in error
      ? new Error(String((error as { message: unknown }).message))
      : new Error('Unknown supabase error');
  Sentry.captureException(wrapped, {
    tags: { area },
    extra: { supabaseError: error },
  });
}
